import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core'
import { MatTabChangeEvent } from '@angular/material'
import { ExecutiveSummaryComponent } from 'app/securities-level/executive-summary/executive-summary.component'
import { BoardShareholderComponent } from 'app/securities-level/board-shareholder/board-shareholder.component'
import { AdditionalInfoComponent } from 'app/securities-level/additional-info/additional-info.component'
import { CpmService } from '../../service/cpm.service'
import { StoreService } from '../../service/store.service'
import { Subscription } from 'rxjs/Subscription'
@Component({
  selector: 'app-securities-level',
  templateUrl: './securities-level.component.html',
  styleUrls: ['./securities-level.component.scss']
})
export class SecuritiesLevelComponent implements OnInit, OnDestroy {
  @ViewChild(ExecutiveSummaryComponent)
  executiveSummaryComponent: ExecutiveSummaryComponent
  @ViewChild(BoardShareholderComponent)
  boardShareholderComponent: BoardShareholderComponent
  @ViewChild(AdditionalInfoComponent)
  additionalInfoComponent: AdditionalInfoComponent
  subscription: Subscription
  displayComponent = false
  constructor(private store: StoreService, private cpmService: CpmService) {}

  ngOnInit() {
    this.subscription = this.store
      .getSecurityProfileNewResultObservable()
      .subscribe(
        response => {
          if (!response) {
            return
          }
          const securitySymbol = response['securitySymbol']
          this.displayComponent = true
          if (securitySymbol === null) {
            this.displayComponent = false
          }
        },
        error => {
          this.displayComponent = false
        }
      )
  }

  onTabClick(event: MatTabChangeEvent) {
    switch (event.index) {
      case 0:
        this.executiveSummaryComponent.ngOnInit()
        break
      case 1:
        this.boardShareholderComponent.getDetailBoardShareholder()
        break
      case 2:
        this.additionalInfoComponent.ngOnInit()
        break
      default:
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/securities-level/securities-level.component.ts